const getOfferId = (url = window.document.location.href) => {
  const offerId = new URL(url).searchParams.get("offer_id")
  if (!offerId) return null
  return offerId
}

export { getOfferId }
